interface SessionSelectorState {
  auth?: {
    session?: {
      token?: string | null;
    } | null;
  };
}

const getSessionTokenSelector = (state: SessionSelectorState) => state.auth?.session?.token || null;

export default getSessionTokenSelector;
